import Advertising from './advertising';
import Ai from './ai';
import Ai2 from './ai-2';
import AlignCenter from './align-center';
import AlignJustify from './align-justify';
import AlignLeft from './align-left';
import AlignRight from './align-right';
import AlignStartHorizontal from './align-start-horizontal';
import AlignStartVertical from './align-start-vertical';
import AlignCenterHorizontal from './align-center-horizontal';
import AlignCenterVertical from './align-center-vertical';
import AlignEndHorizontal from './align-end-horizontal';
import AlignEndVertical from './align-end-vertical';
import Analytics from './analytics';
import Archive from './archive';
import MoveRight from './move-right';
import MoveCenter from './move-center';
import MoveLeft from './move-left';
import MoveUp from './move-up';
import MoveMiddle from './move-middle';
import MoveDown from './move-down';
import ArrowDown from './arrow-down';
import ArrowH from './arrow-h';
import ArrowHw from './arrow-hw';
import ArrowHwIn from './arrow-hw-in';
import ArrowLeft from './arrow-left';
import ArrowRight from './arrow-right';
import ArrowUp from './arrow-up';
import ArrowWh from './arrow-wh';
import Attention from './attention';
import Avatar from './avatar';
import BackUp from './back-up';
import Back from './back';
import Bell from './bell';
import Bold from './bold';
import Bottom from './bottom';
import Boy from './boy';
import Briefcase from './briefcase';
import BrokenImage from './broken-image';
import Button from './button';
import Buttons from './buttons';
import Calendar from './calendar';
import Cart from './cart';
import Chain from './chain';
import CheckSelector from './check-selector';
import Check from './check';
import CheckboxSquare from './checkbox-square';
import Checkboxes from './checkboxes';
import ClearSearch from './clear-search';
import Clock from './clock';
import Close from './close';
import Code from './code';
import Columns from './columns';
import Command from './command';
import Compass from './compass';
import ContactForm from './contact-form';
import ContactUs from './contact-us';
import Content from './content';
import Copy from './copy';
import CreditCard from './credit-card';
import Crop from './crop';
import CustomBlock from './custom-block';
import Database from './database';
import Date from './date';
import Delete from './delete';
import Design from './design';
import Desktop from './desktop';
import DetachGlobal from './detach-global';
import Domain from './domain';
import DownSmall from './down-small';
import DownloadCloud from './download-cloud';
import Download from './download';
import DragIcon from './drag-icon';
import Dropdown from './dropdown';
import Email from './email';
import Embed from './embed';
import EyeOff from './eye-off';
import Eye from './eye';
import Facebook from './facebook';
import Fill from './fill';
import Filter2 from './filter-2';
import Filter from './filter';
import FloatingMenu from './floating-menu';
import FolderMinus from './folder-minus';
import FolderPlus from './folder-plus';
import Folder from './folder';
import FontSize from './font-size';
import Gift from './gift';
import Globe from './globe';
import Grid from './grid';
import Handshake from './handshake';
import Heading1 from './heading-1';
import Heading2 from './heading-2';
import Heading3 from './heading-3';
import Heading4 from './heading-4';
import Heading5 from './heading-5';
import Heading6 from './heading-6';
import HeartCrack from './heart-crack';
import HelpCircle from './help-circle';
import Help from './help';
import Hire from './hire';
import Home from './home';
import Hospitality from './hospitality';
import Html from './html';
import Icons from './icons';
import IdCard from './id-card';
import Iframe from './iframe';
import ImageGallery from './image-gallery';
import ImageReplace from './image-replace';
import Image from './image';
import IndentDecrease from './indent-decrease';
import IndentIncrease from './indent-increase';
import Info from './info';
import InfoItalic from './info-italic';
import Instagram from './instagram';
import IsotopeLayout from './isotope-layout';
import Italic from './italic';
import Key from './key';
import Label from './label';
import Layout from './layout';
import LifeBuoy from './life-buoy';
import Link from './link';
import Linkedin from './linkedin';
import Lock from './lock';
import LogIn from './log-in';
import LogOut from './log-out';
import MailBox from './mail-box';
import Mail from './mail';
import MakeGlobal from './make-global';
import MapMarker from './map-marker';
import Map from './map';
import Maximize from './maximize';
import MessageSquare from './message-square';
import MicVocal from './mic-vocal';
import Minimize from './minimize';
import Minus from './minus';
import Monitor from './monitor';
import More2 from './more-2';
import More from './more';
import Move from './move';
import MultiLine from './multi-line';
import Navigation from './navigation';
import Next from './next';
import OnlineStore from './online-store';
import OpenLink from './open-link';
import OrderedList from './ordered-list';
import Overlay from './overlay';
import PaddingBottom from './padding-bottom';
import PaddingHorizontal from './padding-horizontal';
import PaddingLeft from './padding-left';
import PaddingRight from './padding-right';
import PaddingTop from './padding-top';
import PaddingVertical from './padding-vertical';
import Page from './page';
import Pages from './pages';
import Paragraph from './paragraph';
import Phone from './phone';
import Play from './play';
import PlusForButton from './plus-for-button';
import PlusInCircle from './plus-in-circle';
import Power from './power';
import Publish from './publish';
import Quote from './quote';
import Redo from './redo';
import ReferAFriend from './refer-a-friend';
import Renew from './renew';
import Replace from './replace';
import Reset from './reset';
import Save from './save';
import Search from './search';
import Settings from './settings';
import Share from './share';
import ShoppingBag from './shopping-bag';
import ShoppingCart from './shopping-cart';
import SingleLine from './single-line';
import SliderSettings from './slider-settings';
import SliderSettingsVertical from './slider-settings-vertical';
import SmallLeftArrow from './small-left-arrow';
import Smartphone from './smartphone';
import Social from './social';
import Star from './star';
import Store from './store';
import Tablet from './tablet';
import Tag from './tag';
import Terminal from './terminal';
import TextLong from './text-long';
import TextShort from './text-short';
import ThumbsDown from './thumbs-down';
import ThumbsUp from './thumbs-up';
import Translate from './translate';
import Trash from './trash';
import TypeClean from './type-clean';
import Twitter from './twitter';
import Type from './type';
import Underline from './underline';
import Undo from './undo';
import Unlock from './unlock';
import UnorderedList from './unordered-list';
import Upgrade from './upgrade';
import UploadCloud from './upload-cloud';
import UpSmall from './up-small';
import User from './user';
import Users from './users';
import ViewPublishSite from './view-publish-site';
import WriteComment from './write-comment';
import ZoomIn from './zoom-in';
import ZoomOut from './zoom-out';
import Up from './up';
import SmallRightArrow from './small-right-arrow';
import Payments from './payments';
import Security from './security';
import Down from './down';
import Sale from './sale';
import RadioButtons from './radio-buttons';
import Brush from './brush';
import Sparkles from './sparkles';
import Repeat from './repeat';
import Strikethrough from './strikethrough';
import Loader from './loader';
import Cirle from './circle';
import Magic from './magic';
import PaperPlane from './paper-plane';
import Pen from './pen';
import Retry from './retry';
import Enter from './enter';
import BorderThickness from './border-thickness';
import TextEffects from './text-effects';
import CornerRadius from './corner-radius';
import CornerTopLeftRadius from './corner-top-left-radius';
import CornerTopRightRadius from './corner-top-right-radius';
import CornerBottomLeftRadius from './corner-bottom-left-radius';
import CornerBottomRightRadius from './corner-bottom-right-radius';
import LayoutRight from './layout-right';
import AnimationSpeed from './animation-speed';
import ArrowW from './arrow-w';
import Grid2 from './grid-2';
import GapHorizontal from './gap-horizontal';
import GapVertical from './gap-vertical';
import InterRight from './inter-right';
import LayersOrder from './layers-order';
import LayersBackground from './layers-background';
import LayersForeground from './layers-foreground';
import LayersForward from './layers-forward';
import LayersBackward from './layers-backward';
import DesignColors from './design-colors';
import DesignEffects from './design-effects';
import DesignFonts from './design-fonts';
import DesignSwitch from './design-switch';
import OtherStyles from './other-styles';
import DownSmallForNavItem from './down-small-for-nav-item';
import UpSmallForNavItem from './up-small-for-nav-item';
import LayerArrowDown from './layer-arrow-down';
import LayerArrowUp from './layer-arrow-up';
import MailCheck from './mail-check';
import LineHeight from './line-height';
import Padlock from './padlock';
import CornerDownLeft from './corner-down-left';
import Uppercase from './uppercase';
import Lowercase from './lowercase';
import Capitalization from './capitalization';
const icons = {
  advertising: Advertising,
  ai: Ai,
  'ai-2': Ai2,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  'align-start-horizontal': AlignStartHorizontal,
  'align-start-vertical': AlignStartVertical,
  'align-center-horizontal': AlignCenterHorizontal,
  'align-center-vertical': AlignCenterVertical,
  'align-end-horizontal': AlignEndHorizontal,
  'align-end-vertical': AlignEndVertical,
  analytics: Analytics,
  'animation-speed': AnimationSpeed,
  archive: Archive,
  'move-right': MoveRight,
  'move-center': MoveCenter,
  'move-left': MoveLeft,
  'move-up': MoveUp,
  'move-middle': MoveMiddle,
  'move-down': MoveDown,
  'arrow-down': ArrowDown,
  'arrow-h': ArrowH,
  'arrow-hw': ArrowHw,
  'arrow-hw-in': ArrowHwIn,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-wh': ArrowWh,
  'arrow-w': ArrowW,
  attention: Attention,
  avatar: Avatar,
  'back-up': BackUp,
  back: Back,
  bell: Bell,
  bold: Bold,
  'border-thickness': BorderThickness,
  bottom: Bottom,
  boy: Boy,
  briefcase: Briefcase,
  'broken-image': BrokenImage,
  brush: Brush,
  button: Button,
  buttons: Buttons,
  calendar: Calendar,
  cart: Cart,
  chain: Chain,
  'check-selector': CheckSelector,
  check: Check,
  'checkbox-square': CheckboxSquare,
  checkboxes: Checkboxes,
  circle: Cirle,
  'clear-search': ClearSearch,
  clock: Clock,
  close: Close,
  code: Code,
  columns: Columns,
  command: Command,
  compass: Compass,
  'contact-form': ContactForm,
  'contact-us': ContactUs,
  content: Content,
  copy: Copy,
  'corner-down-left': CornerDownLeft,
  'corner-radius': CornerRadius,
  'corner-top-left-radius': CornerTopLeftRadius,
  'corner-top-right-radius': CornerTopRightRadius,
  'corner-bottom-left-radius': CornerBottomLeftRadius,
  'corner-bottom-right-radius': CornerBottomRightRadius,
  'credit-card': CreditCard,
  crop: Crop,
  'custom-block': CustomBlock,
  database: Database,
  date: Date,
  delete: Delete,
  design: Design,
  'design-colors': DesignColors,
  'design-effects': DesignEffects,
  'design-fonts': DesignFonts,
  'design-switch': DesignSwitch,
  desktop: Desktop,
  'detach-global': DetachGlobal,
  domain: Domain,
  down: Down,
  'down-small': DownSmall,
  'down-small-for-nav-item': DownSmallForNavItem,
  'download-cloud': DownloadCloud,
  download: Download,
  'drag-icon': DragIcon,
  dropdown: Dropdown,
  email: Email,
  embed: Embed,
  enter: Enter,
  'eye-off': EyeOff,
  eye: Eye,
  facebook: Facebook,
  fill: Fill,
  'filter-2': Filter2,
  filter: Filter,
  'floating-menu': FloatingMenu,
  'folder-minus': FolderMinus,
  'folder-plus': FolderPlus,
  folder: Folder,
  'font-size': FontSize,
  gift: Gift,
  globe: Globe,
  grid: Grid,
  'grid-2': Grid2,
  'gap-horizontal': GapHorizontal,
  'gap-vertical': GapVertical,
  handshake: Handshake,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  'heading-4': Heading4,
  'heading-5': Heading5,
  'heading-6': Heading6,
  'heart-crack': HeartCrack,
  'help-circle': HelpCircle,
  help: Help,
  hire: Hire,
  home: Home,
  hospitality: Hospitality,
  html: Html,
  icons: Icons,
  'id-card': IdCard,
  iframe: Iframe,
  'image-gallery': ImageGallery,
  'image-replace': ImageReplace,
  image: Image,
  'indent-decrease': IndentDecrease,
  'indent-increase': IndentIncrease,
  info: Info,
  'info-italic': InfoItalic,
  instagram: Instagram,
  'inter-right': InterRight,
  'isotope-layout': IsotopeLayout,
  italic: Italic,
  key: Key,
  label: Label,
  'layers-background': LayersBackground,
  'layers-backward': LayersBackward,
  'layers-foreground': LayersForeground,
  'layers-forward': LayersForward,
  'layers-order': LayersOrder,
  'layer-arrow-down': LayerArrowDown,
  'layer-arrow-up': LayerArrowUp,
  layout: Layout,
  'layout-right': LayoutRight,
  'life-buoy': LifeBuoy,
  'line-height': LineHeight,
  link: Link,
  linkedin: Linkedin,
  loader: Loader,
  lock: Lock,
  'log-in': LogIn,
  'log-out': LogOut,
  'mail-box': MailBox,
  magic: Magic,
  mail: Mail,
  'mail-check': MailCheck,
  'make-global': MakeGlobal,
  'map-marker': MapMarker,
  map: Map,
  maximize: Maximize,
  'message-square': MessageSquare,
  'mic-vocal': MicVocal,
  minimize: Minimize,
  minus: Minus,
  monitor: Monitor,
  'more-2': More2,
  more: More,
  move: Move,
  'multi-line': MultiLine,
  navigation: Navigation,
  next: Next,
  'online-store': OnlineStore,
  'open-link': OpenLink,
  'ordered-list': OrderedList,
  'other-styles': OtherStyles,
  overlay: Overlay,
  'padding-bottom': PaddingBottom,
  'padding-horizontal': PaddingHorizontal,
  'padding-left': PaddingLeft,
  'padding-right': PaddingRight,
  'padding-top': PaddingTop,
  'padding-vertical': PaddingVertical,
  padlock: Padlock,
  page: Page,
  pages: Pages,
  'paper-plane': PaperPlane,
  paragraph: Paragraph,
  payments: Payments,
  pen: Pen,
  phone: Phone,
  play: Play,
  'plus-for-button': PlusForButton,
  'plus-in-circle': PlusInCircle,
  power: Power,
  publish: Publish,
  quote: Quote,
  'radio-buttons': RadioButtons,
  redo: Redo,
  'refer-a-friend': ReferAFriend,
  renew: Renew,
  repeat: Repeat,
  replace: Replace,
  reset: Reset,
  retry: Retry,
  sale: Sale,
  save: Save,
  search: Search,
  security: Security,
  settings: Settings,
  share: Share,
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  'single-line': SingleLine,
  'slider-settings': SliderSettings,
  'slider-settings-vertical': SliderSettingsVertical,
  'small-left-arrow': SmallLeftArrow,
  'small-right-arrow': SmallRightArrow,
  smartphone: Smartphone,
  social: Social,
  sparkles: Sparkles,
  star: Star,
  store: Store,
  strikethrough: Strikethrough,
  tablet: Tablet,
  tag: Tag,
  terminal: Terminal,
  'text-effects': TextEffects,
  uppercase: Uppercase,
  lowercase: Lowercase,
  capitalization: Capitalization,
  'text-long': TextLong,
  'text-short': TextShort,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  translate: Translate,
  trash: Trash,
  'type-clean': TypeClean,
  twitter: Twitter,
  type: Type,
  underline: Underline,
  undo: Undo,
  unlock: Unlock,
  'unordered-list': UnorderedList,
  upgrade: Upgrade,
  'up-small': UpSmall,
  'up-small-for-nav-item': UpSmallForNavItem,
  up: Up,
  'upload-cloud': UploadCloud,
  user: User,
  users: Users,
  'view-publish-site': ViewPublishSite,
  'write-comment': WriteComment,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
};

const getGlyph = (name) => name && icons[name];

export const iconsList = Object.keys(icons);
export default getGlyph;
